const SUPPORT = {
  LOAD_SUPPORT_FAQS: 'LOAD_SUPPORT_FAQS',
  LOAD_SUPPORT_FAQS_SUCCESS: 'LOAD_SUPPORT_FAQS_SUCCESS',
  LOAD_SUPPORT_FAQS_FAILURE: 'LOAD_SUPPORT_FAQS_FAILURE',
  LOAD_UNAUTHENTICATED_SUPPORT_FAQS: 'LOAD_UNAUTHENTICATED_SUPPORT_FAQS',
  LOAD_UNAUTHENTICATED_SUPPORT_FAQS_SUCCESS: 'LOAD_UNAUTHENTICATED_SUPPORT_FAQS_SUCCESS',
  LOAD_UNAUTHENTICATED_SUPPORT_FAQS_FAILURE: 'LOAD_UNAUTHENTICATED_SUPPORT_FAQS_FAILURE',
  LOAD_GEO_IP_COUNTRY: 'LOAD_GEO_IP_COUNTRY',
  LOAD_GEO_IP_COUNTRY_SUCCESS: 'LOAD_GEO_IP_COUNTRY_SUCCESS',
  LOAD_GEO_IP_COUNTRY_FAILURE: 'LOAD_GEO_IP_COUNTRY_FAILURE',
  LOAD_GET_COUNTRIES: 'LOAD_GET_COUNTRIES',
  LOAD_GET_COUNTRIES_SUCCESS: 'LOAD_GET_COUNTRIES_SUCCESS',
  LOAD_GET_COUNTRIES_FAILURE: 'LOAD_GET_COUNTRIES_FAILURE',
  LOAD_PRODUCT_UPDATE_SUCCESS: 'LOAD_PRODUCT_UPDATE_SUCCESS',
  LOAD_PRODUCT_UPDATE_FAILURE: 'LOAD_PRODUCT_UPDATE_FAILURE',
  LOAD_PRODUCT_UPDATE: 'LOAD_PRODUCT_UPDATE',
  LOAD_DOWNLOAD_MODAL: 'LOAD_DOWNLOAD_MODAL',
  LOAD_DOWNLOAD_URL: 'LOAD_DOWNLOAD_URL'
}

export { SUPPORT };